import React from 'react'
import Header from './include/Header'
import Footer from './include/Footer'
import WhatsAppButton from '../Components/WhatsAppButton'

function Base({ children }) {
    return (
        <>
            <Header />
            {children}
            <Footer />
            <WhatsAppButton />
        </>
    )
}

export default Base